import { NavItem } from "@/types";

export const headerNavLinks: NavItem[] = [
  { label: "Home", href: "/" },
  { label: "Capabilities", href: "/capabilities" },
  { label: "Equipment", href: "/capabilities#equipment" },
  { label: "Training", href: "/training" },
];


export type FooterLink = { label: string; href: string };
export const footerNavigationLinks: FooterLink[] = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Capabilities", href: "/capabilities" },
  { label: "Contact Us", href: "/contact" },
];

export const footerTrainingLinks: FooterLink[] = [
  { label: "Training Modules", href: "/training#training-modules" },
  { label: "Civilian/Recreational Training Programs", href: "/training#civilian-recreational-programs" },
  { label: "Trainers", href: "/training#trainers" },
];

export const footerLegalLinks: FooterLink[] = [
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms & Conditions", href: "/terms-and-conditions" },
];
